import { useState } from 'react';
import './ContactUs.css';
import usaImage from '../assets/images/contact/usa.jpg';
import usaOfficeImage from '../assets/images/contact/usa-office.jpg';
import singaporeImage from '../assets/images/contact/singapore.jpg';
import ukraineImage from '../assets/images/contact/ukraine.jpg';
import indiaImage from '../assets/images/contact/india.jpg';

const initialForm = { name: '', email: '', phone: '', website: '', message: '' };

const mailingAddress = {
  title: 'Mailing Address',
  address: ['P.O. BOX 4127', 'Menlo Park, CA 94026'],
  image: usaImage,
};

const locations = [
  {
    title: 'USA',
    address: ['30 N Gould St', 'Ste R', 'Sheridan, WY 82801'],
    image: usaOfficeImage,
  },
  {
    title: 'Singapore',
    address: ['1 Raffles Place Tower 2', 'Level 19', 'Singapore 048616'],
    image: singaporeImage,
  },
  {
    title: 'Ukraine',
    address: ['58 Yaroslavska str.', 'Astarta, Block A3', 'Kiev, Ukraine'],
    image: ukraineImage,
  },
  {
    title: 'India',
    address: ['26-27 Mahatma Gandhi Road', 'Level 9 Raheja Towers', 'Bengaluru, Karnataka 560001'],
    image: indiaImage,
  },
];

function ContactUs() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('submitted');
    setForm(initialForm);
  };

  return (
    <div className="nw-contact" id="contact">
      <section className="nw-hero" aria-hidden="true" />

      <section className="nw-section nw-heading-section">
        <div className="nw-container">
          <h2 className="nw-page-title">Let&rsquo;s Start the Conversation</h2>
        </div>
      </section>

      <section className="nw-section">
        <div className="nw-container">
          <div className="nw-intro">
            <h3>
              <b>
                Want to Partner with us and leverage our expertise in AI, leading
                technologies, digital marketing,
                <br className="nw-intro-break" />
                applications, or anything else on your mind?
              </b>
            </h3>
            <h3>
              <b>Send us a message and let&rsquo;s get the conversation started.</b>
            </h3>
          </div>

          <div className="nw-form-wrap">
            <form className="nw-form" onSubmit={handleSubmit}>
              {status === 'submitted' && (
                <p className="nw-form-success" role="status">
                  Thanks for contacting us! We will be in touch with you shortly.
                </p>
              )}

              <div className="nw-field">
                <label className="nw-label-hide" htmlFor="nw-name">
                  Name <span>*</span>
                </label>
                <input
                  id="nw-name"
                  type="text"
                  name="name"
                  className="nw-input-medium"
                  placeholder="Your Name *"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="nw-field">
                <label className="nw-label-hide" htmlFor="nw-email">
                  Email <span>*</span>
                </label>
                <input
                  id="nw-email"
                  type="email"
                  name="email"
                  className="nw-input-medium"
                  placeholder="Email *"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="nw-field">
                <label className="nw-label-hide" htmlFor="nw-phone">
                  Phone Number
                </label>
                <input
                  id="nw-phone"
                  type="tel"
                  name="phone"
                  className="nw-input-medium"
                  placeholder="Phone Number"
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="nw-field">
                <label className="nw-label-hide" htmlFor="nw-website">
                  Website
                </label>
                <input
                  id="nw-website"
                  type="text"
                  name="website"
                  className="nw-input-medium"
                  placeholder="Website"
                  value={form.website}
                  onChange={handleChange}
                />
              </div>

              <div className="nw-field">
                <label className="nw-label-hide" htmlFor="nw-message">
                  How can we help? <span>*</span>
                </label>
                <textarea
                  id="nw-message"
                  name="message"
                  placeholder="How can we help? *"
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="nw-submit-container">
                <button type="submit" className="nw-submit">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="nw-section">
        <div className="nw-container">
          <h2 className="nw-locations-title">Locations</h2>
          <div className="nw-divider">
            <span />
          </div>
        </div>
      </section>

      <section className="nw-section nw-locations-row">
        <div className="nw-container nw-location-grid">
          {/* Row 1: Mailing Address, USA, Singapore. Row 2: Ukraine, India */}
          {[mailingAddress, ...locations].map((location) => (
            <div className="nw-location" key={location.title}>
              <img src={location.image} width="150" height="150" alt="" />
              <div className="nw-location-text">
                <div className="card-head">
                  <b>{location.title}</b>
                </div>
                <div className="address">
                  {location.address.map((line, j) => (
                    <span key={line}>
                      {j > 0 && <br />}
                      {line}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="nw-section nw-bottom-spacer" aria-hidden="true" />
    </div>
  );
}

export default ContactUs;
